import { render, staticRenderFns } from "./AbsencesEditor.vue?vue&type=template&id=646e452b&scoped=true&lang=pug&"
import script from "./AbsencesEditor.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e452b",
  null
  
)

export default component.exports